import { LeagueConfig } from '@leagueplatform/cse-core';
import { AppTenant } from 'types';
import { commonCoreConfig } from './common-config';

const {
  VITE_REFERENCE_CONTENT_URL,
  VITE_ENV,
  VITE_REFERENCE_AUTH0_DOMAIN,
  VITE_REFERENCE_AUTH0_CLIENT_ID,
  VITE_WS_API_URL,
  VITE_API_URL,
  VITE_LEGACY_REST_API_URL,
} = import.meta.env;

// update all of this for the reference tenant when its done
export const ReferenceTenant: LeagueConfig = {
  core: {
    ...commonCoreConfig,
    tenantId: AppTenant.ReferenceTenant,
    clientId: `${AppTenant.ReferenceTenant}-web`,
    contentUrl: VITE_REFERENCE_CONTENT_URL,
    appEnvironment: VITE_ENV,
    auth: {
      clientOptions: {
        domain: VITE_REFERENCE_AUTH0_DOMAIN,
        client_id: VITE_REFERENCE_AUTH0_CLIENT_ID,
        redirect_uri: window.location.origin,
        connection: 'SupportAgent-DB',
      },
      idleSessionLifetimeHours: 0.25,
    },
    analytics: {
      segmentKey: 'HGr7PK6lxQ8wWZNFBw8Ya4fM8dbLl8jp',
    },
    api: {
      wsUrl: VITE_WS_API_URL,
      url: VITE_API_URL,
      legacyRestApi: VITE_LEGACY_REST_API_URL,
    },
  },
  customerSupport: {
    enableMemberOverview: true,
    enableActivityOverride: true,
    enableJourneyInquiry: true,
    enableAssessmentsAndDashboards: true,
    enableWalletInquiry: true,
    enableClaimsInquiry: true,
    enableBiometricsV2: true,
    faqLink: 'www.league.com',
    claimsInquiry: {
      featureFlags: {
        shouldShowClaimDetails: true,
        shouldShowDownloadClaims: true,
        shouldShowFilterChips: true,
      },
      showClaimStatusDefinitions: true,
    },
    impersonation: {
      enableImpersonateButton: true,
      impersonationFeedbackUrl: 'https://forms.gle/WE2zzZnV2xjSLZJ96',
      impersonationRedirectUrl:
        'http://sdk-presenter.league.dev/impersonate?tenant=reference&connection=SupportAgent-DB',
    },
  },
};
